var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlusBlue = function SvgPlusBlue(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0316 41.1523C10.1089 41.1523 1.25429 32.2978 1.25429 21.3751C1.25429 10.4524 10.1089 1.59779 21.0316 1.59779C31.9542 1.59779 40.8088 10.4524 40.8088 21.3751C40.8088 32.2978 31.9542 41.1523 21.0316 41.1523Z",
    fill: "#EFF8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0316 41.1523C10.1089 41.1523 1.25429 32.2978 1.25429 21.3751C1.25429 10.4524 10.1089 1.59779 21.0316 1.59779C31.9542 1.59779 40.8088 10.4524 40.8088 21.3751C40.8088 32.2978 31.9542 41.1523 21.0316 41.1523Z",
    stroke: "#0080FF",
    strokeWidth: 2.08182
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0317 14.4357V28.3145",
    stroke: "#0080FF",
    strokeWidth: 3.4697,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0923 21.3751H27.9711",
    stroke: "#0080FF",
    strokeWidth: 3.4697,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlusBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "d7771a8f570597cfe4bce36204549b78.svg";